import { createBrowserHistory } from 'history';

// Create browser history to use in the Redux store
export const browserHistory = createBrowserHistory();

export const navigate = (path: string) => {
  browserHistory.replace(path);
};

export const pushToHistory = (path: string) => {
  browserHistory.push(path);
};
